
export default function search(data, text) {
    return data.filter(post => {
        return post['title'].toLowerCase()
            .includes(text.toLowerCase())
    })
}